// src/layouts/AppLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNavbar from '../components/Navbar';
import { ShowIfLoggedInAndVerified } from '../features/auth/auth_utils';

export default function AppLayoutNoSidebar() {
  return (
    <ShowIfLoggedInAndVerified>
      <TopNavbar />
      <div className="fluid align-items-center justify-content-center d-flex">
          <Outlet />
      </div>
    </ShowIfLoggedInAndVerified>
  );
}
